import { render } from "./SortableIcon.vue?vue&type=template&id=38ccb543"
import script from "./SortableIcon.vue?vue&type=script&lang=js"
export * from "./SortableIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SortableIcon.vue"]])

export default __exports__